/** The `search` area: the Search page. Owned by the stage 2 slot views
 *  (docs/I18N.md §11). */
export const search = {
  'search.page.title': 'Search',
  'search.page.count': { one: '{count} match', other: '{count} matches' },
  /** More hits exist than were counted. */
  'search.page.countMore': { one: '{count}+ match', other: '{count}+ matches' },
  'search.page.prompt': 'Type to search, or add a filter.',
  'search.page.none': 'No matches.',
  'search.page.more': 'More matches than shown - refine the search.',
  'search.page.pager': 'Search result pages',
  'search.controls.placeholder': 'Search work items…',
  'search.controls.label': 'Search work items',
  'search.controls.narrow': 'Narrow by attribute…',
} as const;
